import { Box, Button, ColorOptions, Icon, ModBox, Spacer, Text } from '@jfs/ui-new'
import { useRef } from 'react'
import { Linking, ScrollView } from 'react-native'
import { Config } from 'react-native-config'
import ViewShot from 'react-native-view-shot'
import { SvgImage } from '../../comps/SvgImage'
import { useStores } from '../../data/store'
import { simpleDateFormat } from '../../util/billPaymentUtil'
import { DeviceShare } from '../../util/permissions'
import { Colors, formatAmount } from '../../util/util'
import { BillAmountBreakup } from './BillAmountBreakup'
import { DetailsLayout } from './DetailsLayout'
import { Header } from './Header'

const BillPayTransactionDetails = ({ route }) => {
  const { transaction, status, getOperator, mobile } = useStores((root) => ({
    transaction: root.billPayments.transaction,
    status: root.billPayments.transaction.status,
    getOperator: root.billPayments.getOperator,
    getAllCatogories: root.billPayments.getAllCatogories,
    mobile: root.billPayments.user.mobile,
  }))

  const data = route.params.data ?? {}
  const detailsRef = useRef(null)

  const capture = () => {
    detailsRef.current
      .capture()
      .then((uri) => {
        const shareOptions = {
          url: `${uri}`,
        }
        DeviceShare(shareOptions)
      })
      .catch((e) => console.log('Error while taking screenshot', e))
  }

  const billAmount = data?.payment?.amountDetails?.netAmount ? parseFloat(data?.payment?.amountDetails?.netAmount) : 0
  const agentFeeAmount = data?.payment?.agentFeeAmount ? parseFloat(data?.payment?.agentFeeAmount) : 0
  const chargeAmount = data?.payment?.chargeAmount ? parseFloat(data?.payment?.chargeAmount) : 0
  let total: any = billAmount + agentFeeAmount + chargeAmount
  total = parseFloat(total.toString()).toFixed(2)

  const breakUpData = {
    billAmount: parseFloat(billAmount.toString()).toFixed(2),
    agentFeeAmount: parseFloat(agentFeeAmount.toString()).toFixed(2),
    chargeAmount: parseFloat(chargeAmount.toString()).toFixed(2),
    total: total,
  }

  const convertTime = (timestamp: any) => {
    const dateObj = new Date(timestamp)
    const dateTime = simpleDateFormat(dateObj, 'dd MMM yyyy, hh:mm aaa')
    return dateTime
  }

  const mail = () => {
    const time = convertTime(data?.payment?.paymentAt)
    const list = [
      { key: 'Transaction ID', value: data?.id },
      { key: 'Transaction Amount', value: `${'\u20B9'} ${formatAmount(data?.payment?.amountDetails?.netAmount)}` },
      { key: 'Transaction Status', value: status },
      { key: 'Date and Time', value: time },
      { key: 'Mobile Number', value: mobile },
    ]

    let body: any = 'Hi, \n\n'
    list?.map((item: any) => {
      if (item?.value) {
        body += `${item.key}: ${item.value}; \n\n`
      }
    })
    const encode = encodeURIComponent(body)
    const receipients = Config.REACT_APP_COMPLAINT_MAIL_ID
    const subject = 'Bill Payment Transaction Issue'
    Linking.openURL(`mailto:${receipients}?subject=${subject}&body=${encode}&content-type=text/plain`).catch((err) =>
      console.error('An error occurred', err),
    )
  }

  return (
    <Box bg={'SECONDARY'} pt={64} f={1}>
      <Box
        f={1}
        overflow={'hidden'}
        bg={'WHITE'}
        borderTopLeftRadius={24}
        borderTopRightRadius={24}
        justifyContent="space-between">
        <ScrollView showsVerticalScrollIndicator={true} contentContainerStyle={{ flexGrow: 1 }}>
          <ViewShot ref={detailsRef} captureMode="mount" options={{ format: 'jpg', quality: 1, result: 'tmpfile' }}>
            <Box f={1} bg={'WHITE'} ph={24} pt={30}>
              <Header
                data={data}
                amount={data?.payment?.amountDetails?.netAmount}
                //txnStatus={data?.status === REFUND_INITIATED ? 'FAILED' : data?.status}
                name={data?.product?.name}
                timestamp={data?.payment?.paymentAt}
                logoPath={data.logoPath}
              />
              <Box borderWidth={1} borderColor={'DISABLED_GREY'} borderRadius={8} p={16}>
                <DetailsLayout data={data} />
              </Box>
              <Spacer size={16} direction={'vertical'} />
              <Box borderWidth={1} borderColor={'DISABLED_GREY'} borderRadius={8} p={16}>
                <BillAmountBreakup data={breakUpData} />
              </Box>
            </Box>
          </ViewShot>
          <ModBox ph={24}>
            <Box
              borderWidth={1}
              borderColor={'DISABLED_GREY'}
              borderRadius={8}
              ph={16}
              pv={12}
              overflow={'auto'}
              align={'center'}
              justify={'space-between'}
              marginVertical={24}
              onPress={mail}
              testID="btn-help"
              underlayColor={'TRANSPARENT'}
              flexDirection="row">
              <Text
                title={'Need help?'}
                fontFamily={'JioType-Bold'}
                fontSize={14}
                lineHeight={24}
                letterSpacing={-0.07}
                color={Colors.BLACK_14 as ColorOptions}
              />
              <Icon id={'ARROW_RIGHT'} color={'BLACK'} size={16} />
            </Box>
          </ModBox>
        </ScrollView>
        <Box ph={24} pb={15}>
          <Spacer size={10} direction="vertical" />
          <Button
            color={'WHITE'}
            height={50}
            type="secondary"
            onPress={capture}
            testID="btn-share"
            isRound
            isFull={true}
            underlayColor={'TRANSPARENT'}>
            <Box flexDirection={'row'} align="center">
              <SvgImage color={Colors.PRIMARY} imageName="Share" />
              <Spacer size={10} direction="horizontal" />
              <Text fontFamily="JioType-Bold" fontSize={16} color={'PRIMARY'}>
                Share
              </Text>
            </Box>
          </Button>
        </Box>
      </Box>
    </Box>
  )
}

export default BillPayTransactionDetails
